const ITEMS = [
  "Premium Plots in Nagpur",
  "Samruddhi Mahamarg",
  "Umred\u2013Wardha Road",
  "Residential Plots",
  "Commercial Plots",
  "Land Investment",
];

export default function Marquee() {
  return (
    <div
      data-testid="editorial-marquee"
      className="overflow-hidden border-y border-navy/10 bg-white py-5"
      aria-hidden="true"
    >
      <div className="flex w-max animate-marquee items-center">
        {[...ITEMS, ...ITEMS, ...ITEMS, ...ITEMS].map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="whitespace-nowrap px-8 font-display text-lg italic text-navy/70">{item}</span>
            <span className="text-gold">&#9670;</span>
          </span>
        ))}
      </div>
    </div>
  );
}
